import { Button, Card, Col, Container, Row } from "react-bootstrap";
import CoursePlan from "../../docs/RDL7702CourseOutline.pdf";
import Background from "../../image/iitbg.jpg";

export default function LifeSkills() {
    return(
    <>
    <Container fluid style={{background: "url(" + Background + ") no-repeat fixed center"}}>
    <Container>
        <Row className="justify-content-center section">
            <Col md="8" sm="12" className="image-over-section">
                <h2 style={{textAlign:"center"}}>Life Skills</h2>
            </Col>
        </Row>
    </Container>
    </Container>

    <Container className="section">

            <h2 style={{paddingTop:"30px"}}>Course Modules (In Person)</h2>
        <Row xs="1" sm="3" md="3">
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 1: Institute Awareness: Campus, Resource, Expectations
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 2: Workshop on Vision/Career/Goal Setting
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 3: Self-Awareness: Goal Setting & Career Introduction
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 4: Workshop on Time/Stress Management
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 5: Self-Management - Financial, Health, Stress, Time
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 6: Study Skills & Learning Styles
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 7: Workshop on Digital Wellness/Social Media
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                        Module 8: Digital Literacy, Online Safety, and Generative AI
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 9: Workshop on Understanding Diversity & Striving for Harmony
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col> 

            <Col>
                <Card className="publications-list module">
                    <Card.Body>
                        <Card.Text>
                            Module 10: Emotional Intelligence for the well-being of Self and Surroundings
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>          
        </Row>
    </Container>
    </>
    )
}